module.exports = __webpack_public_path__ + "img/press-media_2.4904a69b.jpg";